import { VueConstructor } from 'vue';
import VueCompositionApi from '@vue/composition-api';
import VueRouter from 'vue-router';
import VueI18n from 'vue-i18n';
import { PiniaVuePlugin } from 'pinia';
import { VTooltip, config } from './vendor/v-tooltip';

export function applyPlugins(vue: VueConstructor): void {
	vue.use(VueCompositionApi);
	vue.use(VueI18n);
	vue.use(VueRouter);
	vue.use(VTooltip, config);
	vue.use(PiniaVuePlugin);
}
